// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"71316867","492":"57ef16e5","546":"98bf0e5e","634":"8ae04fe6","985":"0e219862"}[chunkId] + ".chunk.js";
};